import React from 'react';
import {reach} from '@hapi/hoek';
import Page from '../../components/Page/Page';
import Header from '../../components/Header/Header';
import CategoryNavigation from '../../components/CategoryNavigation/CategoryNavigation';
import withQuery from '../../utils/withQuery';

const LoadedPage = (props) => {
    const {
        client,
        response,
        systemData,
        match,
        location,
        homeRoute,
        logo,
        preview,
    } = props;
    const {isMobile} = systemData;
    const slug = match.params.slug || '';
    const categories = reach(response, 'data.allCategories.items');
    const translations = reach(response, 'data.translationsCollection.items.0');
    const homeId = reach(response, 'data.homeCollection.items.0.sys.id');
    const socialShares = reach(
        response,
        'data.homeCollection.items.0.socialShare',
    );
    const navProps = {
        categories,
        homeId,
        isMobile,
        location,
        translations,
    };

    return (
        <Page
            client={client}
            allCategories={categories}
            translations={translations}
            systemData={systemData}
            homeId={homeId}
            slug={slug}
            preview={preview}
            location={location}
            socialShares={socialShares}
        >
            {(partitionedNavProps) => {
                return (
                    <Header
                        translations={translations}
                        isMobile={isMobile}
                        slug={slug}
                        location={location}
                        homeRoute={homeRoute}
                        logo={logo}
                        {...partitionedNavProps}
                    >
                        <CategoryNavigation
                            {...partitionedNavProps}
                            {...navProps}
                        />
                    </Header>
                );
            }}
        </Page>
    );
};

export default withQuery(LoadedPage);
